import { Controller as BaseController } from "@hotwired/stimulus"

export class Controller extends BaseController {
  static targets = ["buttonText", "content", "button", "field"]
  static values = {
    expanded: Boolean,
  }

  connect() {
    this.expandedValue = this.expandedValue || false
    this.savedValues = {}
  }

  toggle() {
    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged(value) {
    if (value) {
      this._expand()
    } else {
      this._collapse()
    }
  }

  _expand() {
    const buttonText = this.buttonTarget.dataset.expandedText
    this.buttonTextTarget.textContent = buttonText
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.buttonTarget.classList.add("rounded-none")
    this.contentTarget.classList.remove("hidden")
    this.restoreValues()
  }

  _collapse() {
    const buttonText = this.buttonTarget.dataset.defaultText
    this.buttonTextTarget.textContent = buttonText
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.buttonTarget.classList.remove("rounded-none")
    this.contentTarget.classList.add("hidden")
    this.resetValues()
  }

  restoreValues() {
    this.savedValues ||= {}

    this.fieldTargets.forEach((field) => {
      field.value = this.savedValues[field.name] || field.value
    })
  }

  resetValues() {
    this.savedValues ||= {}
    this.savedValues[this.fieldTarget.name] = this.fieldTarget.value

    this.fieldTargets.forEach((field) => {
      field.value = ""
    })
  }
}
